export function filterUndefined(object: {
  onlyWithGlobalRadiation?: boolean;
  altitude: number[] | undefined;
  onlyCurrent?: boolean;
  endDate?: Date;
  name?: string;
  onlyWithSunshine?: boolean;
  id?: string;
  startDate?: Date;
  states?: string[];
}): { [p: string]: unknown } {
  return Object.fromEntries(
    Object.entries(object).filter((entry) => entry[1] !== undefined)
  );
}

export function scalarArraysAreEqual(
  array1: number[],
  array2: number[]
): boolean {
  return (
    array1.length === array2.length &&
    array1.every((value, index) => value === array2[index])
  );
}
